import apiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getTenantByFeatureFlag = (token, id, search, type) => {
    return fetch(`${apiUrl}tenants_by_feature_flag/${id}?search=${search}&type=${type}`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
}

export default getTenantByFeatureFlag